import { Component, Input } from '@angular/core';

export type StatCardColor = 'brand' | 'blue' | 'orange' | 'red' | 'purple' | 'navy' | 'teal';

const COLOR_MAP: Record<StatCardColor, { bg: string; text: string }> = {
  brand: { bg: 'bg-green-50', text: 'text-green-600' },
  blue: { bg: 'bg-blue-100', text: 'text-blue-500' },
  orange: { bg: 'bg-orange-100', text: 'text-orange-500' },
  red: { bg: 'bg-red-100', text: 'text-red-500' },
  purple: { bg: 'bg-purple-100', text: 'text-purple-500' },
  navy: { bg: 'bg-indigo-100', text: 'text-indigo-700' },
  teal: { bg: 'bg-teal-100', text: 'text-teal-600' }
};

@Component({
  selector: 'share-stat-card',
  templateUrl: './share-stat-card.component.html'
})
export class ShareStatCardComponent {
  @Input() icon = 'pi pi-chart-bar';
  @Input() label = '';
  @Input() value: string | number | null = null;
  @Input() loading = false;
  @Input() color: StatCardColor = 'brand';
  @Input() suffix = '';

  get iconBg(): string {
    return COLOR_MAP[this.color]?.bg ?? COLOR_MAP.brand.bg;
  }
  get iconColor(): string {
    return COLOR_MAP[this.color]?.text ?? COLOR_MAP.brand.text;
  }
}
